export const sortByAssignment = (a, b) => {
  if (a === '') {
    if (b === '') return 0;
    return -1;
  }
  if (b === '') {
    return 1;
  }
  if (a === null) {
    if (b === null) return 0;
    return 1;
  }
  if (b === null) {
    return -1;
  }

  if (a > b) return 1;
  if (b > a) return -1;
  return 0;
};
